import request from '@/utils/request'

let SignApi = {
    // 获取报名相关信息
    getSignInfo(data, errorback) {
        return request._post('/supplier/sign.sign/index', data, errorback);
    },

    // 添加报名
    addSign(data, errorback) {
        return request._post('/supplier/sign.sign/add', data, errorback);
    },

    // 报名详情
    getSignDetail(data, errorback) {
        return request._post('/supplier/sign.sign/detail', data, errorback);
    },

    // 修改报名信息
    editSign(data, errorback) {
        return request._post('/supplier/sign.sign/edit', data, errorback);
    },

    // 报考缴费
    getSignPay(data, errorback) {
        return request._post('/supplier/sign.sign/pay', data, errorback);
    },

    // 我的报考
    getMySignList(data, errorback) {
        return request._post('/supplier/sign.sign/list', data, errorback);
    },

    // 打印准考证
    getMyAdmissionList(data, errorback) {
        return request._post('/supplier/sign.sign/admission', data, errorback);
    },

    // 我的成绩
    getMyScoreList(data, errorback) {
        return request._post('/supplier/sign.sign/score', data, errorback);
    },

}

export default SignApi;



// WEBPACK FOOTER //
// ./src/api/sign.js